/**
 * Utility functions for text handling
 */

/**
 * Checks if a value is a number
 * @param {any} value - The value to check
 * @returns {boolean} True if the value is a number, false otherwise
 */
export function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}

// Make isNumber available globally
window.isNumber = isNumber; 